<template>
  <div class="limits">
    <signboard v-if="ISshow" :signboardName="signboardName"></signboard>
    <div v-if="ISshow" class="list">
      <div class="row">
        <div>甲方名称</div>
        <div>{{info.name}}</div>
      </div>
      <div class="row">
        <div>授信日期</div>
        <div>{{info.date}}</div>
      </div>
      <div class="row">
        <div>剩余金额</div>
        <div class="balance">¥{{info.balance}}</div>
      </div>
      <div class="row">
        <div>总金额</div>
        <div>¥{{info.aggregateAmount}}</div>
      </div>
      <div class="row">
        <div>已用金额</div>
        <div>¥{{info.already}}</div>
      </div>
    </div>
    <noContent style="padding-top: 100px;" v-if="!ISshow" img = '1' explain="抱歉，暂未查询到您的额度!"></noContent>
  </div>
</template>

<script>
import signboard from "@/components/signboard";
import API from "../../../api/setTing";
import noContent from "@/components/noContent";
const api = new API();
export default {
  components:{noContent,signboard},
   data() {
    return {
      ISshow:true,
      nowDate:null,
      signboardName:'额度',
      info:{name:'',date:'',balance:'',aggregateAmount:'',already:''},
    }
   },
  methods:{
    //查询客户基础信息
    async getCustomerCredit(){
      let parme = {
        "msg":""
      }
      let res = await api.getCustomerCredit(parme);
      console.info(res.data);
      if(res){
        this.info.name = res.data.customerName;
        this.info.aggregateAmount = res.data.creditAmount;
        this.info.already = res.data.usedAmount;
        this.info.balance = res.data.unusedAmount;
        this.info.date = "";
      }else {
        this.ISshow = false
        // this.$message("抱歉，暂未查询到您的额度!");
      }

    },
    getTime(){
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour= date.getHours();

      this.month=check(month);
      this.day=check(day);
      this.hour=check(hour);
      function check(i){
        const num = (i<10)?("0"+i) : i;
        return num;
      }
      this.nowDate = year + "年" + this.month + "月" + this.day+"日";
    },
  },
  created() {
    this.getCustomerCredit()
    this.getTime();
  }
}
</script>

<style lang='less' scoped>
.limits {
  width: 100%;
  height: 100%;

  .list {
    margin-left: 32px;
    width: 433px;
    border: 1px solid #EAEAEA;
    border-bottom: 0px;
    font-size: 14px;
    color: #323233;
    .row {
      width: 100%;
      display: flex;
      border-bottom: 1px solid #EAEAEA;
      line-height: 44px;
      .balance {
        font-weight: 600;
        color: #059800;
      }
    }
    .row>div:first-child {
      width: 100px;
      background: #F6F6F6;
      text-align:right;
      padding-right: 12px;
    }
    .row>div:last-child {
      padding-left: 12px;
    }
    
  }
}
</style>